import styled from "styled-components"
import { Chart } from "primereact/chart"

const StyledLineGraph = styled(Chart)`
  width: 100%;
`
export default StyledLineGraph
